import { FormEvent } from "../../../core/entities/formEvent";
import { mapStatusCodeToStatusText } from "../../../core/functions/MapStatusCodeToStatusText";
import { mapErrorCodeToErrorText } from "../../../core/functions/MapErrorCodeToErrorText";
import { FormEventDto } from "../formEventDto";

export function mapDtoToFormEvent(formEventDto: FormEventDto): FormEvent {
    return {
        id: formEventDto.id,
        formId: formEventDto.formId,
        status: formEventDto.status,
        statusText: mapStatusCodeToStatusText(formEventDto.status),
        statusEventTimeUtc: new Date(formEventDto.statusEventTimeUtc),
        errorCode: formEventDto.errorCode,
        errorText: formEventDto.errorText,
        errorTextOverrideDescription: formEventDto.errorCode
            ? mapErrorCodeToErrorText(formEventDto.errorCode)
            : formEventDto.errorText,
        errorTraceId: formEventDto.errorTraceId,
        isStateEvent: formEventDto.isStateEvent
    };
}
